import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { href: '/', label: '首页' },
    { href: '/category/kr', label: '韩漫专区' },
    { href: '/category/jp', label: '日漫专区' },
    { href: '/category/cn', label: '国漫专区' },
    { href: '/about', label: '关于我们' },
  ],
  热门分类: [
    { href: '/category/kr', label: '热血韩漫' },
    { href: '/category/jp', label: '奇幻日漫' },
    { href: '/category/cn', label: '玄幻国漫' },
    { href: '/category/kr', label: '爱情韩漫' },
    { href: '/category/jp', label: '校园日漫' },
  ],
  帮助支持: [
    { href: '/about', label: '联系我们' },
    { href: '/about', label: '常见问题' },
    { href: '/about', label: '用户反馈' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-2xl font-heading font-bold text-white">漫蛙漫画</span>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              漫蛙漫画网 — 免费韩漫日漫国漫大全，高清漫画全集在线阅读平台。找好看的漫画，就来漫蛙漫画网。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm" />
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 漫蛙漫画网 manwacomics.com — 版权所有
          </p>
          <p className="text-xs text-secondary-400">
            本站所有漫画资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}